module.exports = __webpack_public_path__ + "img/u3080.87d6626a.svg";